import { Component, Input, HostBinding } from '@angular/core';

type BadgeContentDirection = 'row' | 'column';
type BadgeContentJustify = 'start' | 'end' | 'center';

@Component({
  selector: 'span[app-badge-content]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['badge-content.component.scss'],
})
export class BadgeContentComponent {
  @Input() direction: BadgeContentDirection = 'row';
  @Input() justify: BadgeContentJustify = 'center';

  @HostBinding('class.badge-content') readonly isBadgeContent = true;

  @HostBinding('class.badge-content--row') get isRow() {
    return this.direction === 'row';
  }

  @HostBinding('class.badge-content--column') get isColumn() {
    return this.direction === 'column';
  }

  @HostBinding('class.badge-content--justify-start') get isJustifyStart() {
    return this.justify === 'start';
  }

  @HostBinding('class.badge-content--justify-end') get isJustifyEnd() {
    return this.justify === 'end';
  }

  @HostBinding('class.badge-content--justify-center') get isJustifyCenter() {
    return this.justify === 'center';
  }
}
